import {UIGameManager} from '../UIGameManager'
import {InGameAchievement} from './UIGameAchievementController'
import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI} from '@colonist/pixi'
import {GameColor} from '../../GameColor'
import {UIGameAchievementTitleSectionView} from './UIGameAchievementTitleSectionView'
import {UIGameAchievementDescriptionSectionView} from './UIGameAchievementDescriptionSectionView'
import {UIGameAchievementBackgroundView} from './UIGameAchievementBackgroundView'

export abstract class UIGameBaseAchievementView extends PIXI.Container {
    protected readonly achievementOptions: InGameAchievement
    protected readonly uiGameManager: UIGameManager
    protected readonly titleSection: UIGameAchievementTitleSectionView
    protected readonly itemSize: number
    protected descriptionSection: UIGameAchievementDescriptionSectionView
    protected readonly margin: number

    readonly mainContainer: SectionBgView

    protected constructor(options: InGameAchievement, uiGameManager: UIGameManager, x: number, y: number, w: number, h: number, avatarSize: number) {
        super()
        this.achievementOptions = options
        this.uiGameManager = uiGameManager
        this.itemSize = this.uiGameManager.canvasController.itemSize
        this.margin = h / 8
        this.mainContainer = new SectionBgView(x, y, w, h, this, true)

        const titleSectionHeight = this.mainContainer.height * 0.45
        const initialDescriptionHeight = this.margin

        this.titleSection = new UIGameAchievementTitleSectionView(0, 0, this.mainContainer.width, titleSectionHeight, this.mainContainer, this.achievementOptions, this.margin)
        this.descriptionSection = new UIGameAchievementDescriptionSectionView(0, this.titleSection.height, this.mainContainer.width, initialDescriptionHeight, this.mainContainer, this.uiGameManager, this.achievementOptions, this.margin, avatarSize)
        this.createMiddleLine()
    }

    drawBackground() {
        const height = this.titleSection.height + this.descriptionSection.height + this.margin * 1.2
        const width = this.mainContainer.width
        this.mainContainer.removeChild(this.mainContainer.bg)
        this.mainContainer.bg = new UIGameAchievementBackgroundView(width, height)
        this.mainContainer.addChild(this.mainContainer.bg)
        this.mainContainer.setChildIndex(this.mainContainer.bg, 0)
    }

    private createMiddleLine() {
        const middleLine = new PIXI.Graphics()
        const line = {
            width: this.mainContainer.width * 0.002,
            alpha: 0.6,
            color: GameColor.getColorHexValue(GameColor.Color.White),
            x1: this.margin,
            y: this.titleSection.height,
            x2: this.mainContainer.width - this.margin,
        }
        middleLine.lineStyle(line.width, line.color, line.alpha)
        middleLine.moveTo(line.x1, line.y)
        middleLine.lineTo(line.x2, line.y)
        this.mainContainer.addChild(middleLine)
    }
}
